import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { FeaturebaseProvider, useFeaturebase } from "featurebase-js/react";

function isControlPanelPath(pathname) {
  return (
    pathname === "/r" ||
    pathname.indexOf("/r/") === 0 ||
    pathname.indexOf("/gm/") === 0
  );
}

function getUserName(auth, profile) {
  const first =
    (profile && (profile.firstName || profile.first_name)) ||
    (profile && profile.name && profile.name.first);
  const last =
    (profile && (profile.lastName || profile.last_name)) ||
    (profile && profile.name && profile.name.last);

  if (first && last) return `${first} ${last}`.trim();
  if (first) return first;
  if (profile && profile.fullName) return profile.fullName;
  if (auth && auth.displayName) return auth.displayName;
  return undefined;
}

function FeaturebaseControlPanelGuard() {
  const location = useLocation();
  const { hide } = useFeaturebase();
  const onControlPanel = isControlPanelPath(location.pathname);

  useEffect(() => {
    if (onControlPanel) {
      hide();
    }
  }, [onControlPanel, hide]);

  return null;
}

function FeaturebaseRoot({ children, auth, profile }) {
  const location = useLocation();
  const onControlPanel = isControlPanelPath(location.pathname);
  const userId = auth && auth.uid ? auth.uid : undefined;
  const email =
    (auth && auth.email) || (profile && profile.email) || undefined;
  const name = getUserName(auth, profile);
  const accountId = profile && profile.account_id ? profile.account_id : undefined;

  return (
    <FeaturebaseProvider
      appId="692c69f5061307b3df588b4f"
      hideDefaultLauncher={onControlPanel}
      messenger={!onControlPanel}
      {...(userId
        ? {
            userId,
            email,
            name,
            tags: ["Bolt V1"],
            ...(accountId ? { customData: { account_id: accountId } } : {}),
          }
        : {})}
    >
      <FeaturebaseControlPanelGuard />
      {children}
    </FeaturebaseProvider>
  );
}

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
  profile: state.firebase.profile,
});

export default connect(mapStateToProps)(FeaturebaseRoot);
